import {API_SERVERLESS, getFetch} from './index';

export function apiUserClients(): Promise<{clients: {clientId: string; name: string}[]}> {
    return getFetch(`${API_SERVERLESS}/common/v3/userClients`, true);
}
